import axios from "axios";
import { apiUrl } from "./axiosProvider";
import { getCookie } from "../context/useCookies";

const apiClient = axios.create({
  baseURL: apiUrl,
});

export function authHeader() {
  let user = getCookie("accessToken")?.replace(/^"|"$/g, "");

  if (user) {
    return { Authorization: "Bearer " + user };
  } else {
    return {};
  }
}
export const headerForPrivateAPI = new Headers({
  "Content-Type": "application/json",
  Authorization: authHeader().Authorization,
});

export const setHeaders = () => {
  let user = getCookie("accessToken")?.replace(/^"|"$/g, "");

  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user,
    },
  };
};

export function logoutFunction() {
  localStorage.removeItem("accessToken");

  window.location.replace("/login");
  window.location.reload();
}

export const apiRequest = async (
  method,
  endpoint,
  data,
  contentType = "json",
) => {
  let user = getCookie("accessToken")?.replace(/^"|"$/g, "");

  try {
    const response = await apiClient({
      method: method,
      url: endpoint,
      ...(method === "GET" ? { params: data } : { data: data }),
      headers: {
        "Content-Type":
          contentType === "json" ? "application/json" : "multipart/form-data",
        Authorization: "Bearer " + user,
      },
    });

    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: "Unknown error occurred" };
  }
};

export const apiRequestImage = async (method, endpoint, data) => {
  let user = getCookie("accessToken")?.replace(/^"|"$/g, "");

  try {
    const response = await apiClient({
      method: method,
      url: endpoint,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${user}`,
      },
    });

    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: "Unknown error occurred" };
  }
};

export const apiRequestVideo = async (method, endpoint, data) => {
  let user = getCookie("accessToken")?.replace(/^"|"$/g, "");

  try {
    const response = await apiClient({
      method: method,
      url: endpoint,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${user}`,
      },
    });

    return response.data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: "Unknown error occurred" };
  }
};
